import { ChevronLeft, Phone, MapPin, CheckCircle2, Send } from "lucide-react";
import { C, Panel, Chip, Serif, Label } from "./ui";
import { TIMELINE } from "./adminData";

const dot = { panic: C.red, dispatch: C.green, info: C.slate };

export default function IncidentDetail({ nav }) {
  return (
    <div>
      <button onClick={() => nav("ops")} data-testid="incident-back" style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "none", border: 0, color: C.slate, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
        <ChevronLeft size={16} /> Ops Console
      </button>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 18 }}>
        <div>
          <Label>Incident · RSQ-2026-0042</Label>
          <Serif size={24} style={{ marginTop: 4 }}>Johan Bekker</Serif>
        </div>
        <Chip color={C.red} solid>SECURITY · ACTIVE</Chip>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 16 }}>
        <div style={{ display: "grid", gap: 16 }}>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Requester</Label>
            {[["Name", "Johan Bekker"], ["Cell", "+27 81 555 0182"], ["Insurer", "Indwe · agent ef7e9e"], ["Plan", "Family"], ["Battery", "18% · low"]].map(([k, v]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid rgba(26,30,36,0.06)", fontSize: 13 }}>
                <span style={{ color: C.slate }}>{k}</span><span style={{ fontWeight: 600, color: C.ink }}>{v}</span>
              </div>
            ))}
          </Panel>
          <Panel>
            <Label style={{ marginBottom: 10 }}><MapPin size={12} style={{ verticalAlign: "middle" }} /> Location</Label>
            <div style={{ height: 130, background: "linear-gradient(135deg,#1a2332,#0f1720)", borderRadius: 8, position: "relative" }}>
              <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-100%)", width: 16, height: 16, background: C.red, borderRadius: "50% 50% 50% 0", rotate: "-45deg" }} />
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, marginTop: 10 }}>18 Rosmead Ave, Kenilworth</div>
            <div style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>-33.99841, 18.47210 · ±9m</div>
          </Panel>
        </div>

        <div style={{ display: "grid", gap: 16, alignContent: "start" }}>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Dispatch actions</Label>
            <div style={{ display: "grid", gap: 8 }}>
              <button data-testid="incident-dispatch" style={{ padding: 12, background: C.red, color: "#fff", border: 0, borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}><Send size={15} /> Dispatch to CSG (mock)</button>
              <button style={{ padding: 12, background: "#fff", color: C.navy, border: `1px solid ${C.navy}`, borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}><Phone size={15} /> Call requester</button>
              <button style={{ padding: 12, background: "#fff", color: C.green, border: `1px solid ${C.green}`, borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}><CheckCircle2 size={15} /> Resolve incident</button>
            </div>
          </Panel>
          <Panel>
            <Label style={{ marginBottom: 12 }}>Audit timeline</Label>
            {TIMELINE.map((e, i) => (
              <div key={i} style={{ display: "flex", gap: 10, paddingBottom: 12 }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span style={{ width: 9, height: 9, borderRadius: "50%", background: dot[e.tag] }} />
                  {i < TIMELINE.length - 1 && <span style={{ flex: 1, width: 1, background: "rgba(26,30,36,0.12)" }} />}
                </div>
                <div>
                  <div style={{ fontSize: 11, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{e.t}</div>
                  <div style={{ fontSize: 13, color: C.ink }}>{e.e}</div>
                </div>
              </div>
            ))}
          </Panel>
        </div>
      </div>
    </div>
  );
}
